export const RenderingMethods = {
  UNCONDITIONAL: "Always render",
  CONDITIONAL_PREVIOUS_QUESTION:
    "Render conditionally, based on response to previous question",
  CONDITIONAL_PREDEFINED_PROPERTY:
    "Render conditionally, based on a predefined property",
};
